<template>
  <div class="calendar-body-container">
    <div class="table-header">
      <div class="table-header-item body-col" v-for="(weekText,index) in tableHeader" :key="index">
        {{weekText}}
      </div>
    </div>

    <div class="table-body-wrap">
      <date-item v-for="(item,index) in currentMonthData" :key="index" :update="update" :dateItem="item" :disabled="!currentDate.isSame(item.date,'month')" @clickEvent="handleClickEvent" class="body-col"></date-item>
    </div>
  </div>
</template>

<script>
import dateItem from './date-item'
export default {
  name: "calendar-body",
  components: {
    dateItem
  },
  props:{
    currentMonthData:{
      type:Array,
      default:()=>{
        return []
      }
    },
    currentDate:{
      type:Object,
      default:()=>{
        return this.$dayjs()
      }
    },
    update:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    tableHeader(){
      return [
        'SUNDAY',
        'MONDAY',
        'TUESDAY',
        'WEDNESDAY',
        'THURSDAY',
        'FRIDAY',
        'SATURDAY'
      ]
    }
  },
  methods:{
    handleClickEvent(e){
      this.$emit("clickEvent",e)
    }
  }
};
</script>

<style lang="scss" scoped>
  .body-col{
    width:calc(100% / 7);
  }
  .calendar-body-container{
    width:100%;
    height:calc(100% - 80px);
    background: white;
    .table-header{
      width:100%;
      display: flex;
      .table-header-item{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size:13px;
        color:rgb(103,106,108);
        font-weight: 600;
        height:38px;
        overflow: hidden;
      }
    }
    .table-body-wrap{
      width:100%;
      height:calc(100% - 38px);
      display: flex;
      flex-wrap: wrap;
    }
    
  }
</style>
